import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ index, label, title, lead, dark = false, center = false }) => (
    <div className={center ? "text-center" : ""}>
        <Reveal>
            <h2
                className={`mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.12] ${
                    dark ? "text-white" : "text-brand-ink"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {lead && (
            <Reveal delay={0.16}>
                <p
                    className={`mt-5 text-base sm:text-lg leading-relaxed max-w-2xl ${
                        center ? "mx-auto" : ""
                    } ${dark ? "text-white/80" : "text-brand-gray"}`}
                >
                    {lead}
                </p>
            </Reveal>
        )}
    </div>
);
